import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Pagination } from "src/app/utility/services/paging/paging";
@Injectable({
  providedIn: "root",
})
export class ValidateEnrolService {
  routePrefix = "/api/GCSubmission";
  requestTokenKey = 'requestToken';
  requestToken: string;
  constructor(private http: HttpClient) { }

  getRequestTokenHeader(): HttpHeaders {
    this.requestToken = sessionStorage.getItem(this.requestTokenKey);
    return new HttpHeaders().set(this.requestTokenKey, this.requestToken);
  }

  clearRequestToken() {
    sessionStorage.removeItem(this.requestTokenKey);
  }

  getById(id: number): Observable<any> {
    return this.http.get(this.routePrefix + "/get/" + id);
  }

  gets(): Observable<any> {
    return this.http.get(this.routePrefix + "/gets");
  }

  edit(id: number, data): Observable<any> {
    return this.http.put(this.routePrefix + "/edit/" + id, data);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(this.routePrefix + "/delete/" + id);
  }

  findClaim(
    groupPolicyNo: string,
    birthYear: number,
    certificateNo: string,
    recaptcha: string,
  ): Observable<any> 
  {
    const body = {
      groupPolicyNumber: groupPolicyNo.toString(),
      birthYear: birthYear,
      certificateNumber: certificateNo.toString(),
      recaptcha: recaptcha,
    };
    return this.http.post(this.routePrefix + "/findClaim", body);
  }

  validateClaimAndGenerateOTP(
    claimNumber: string,
    birthYear: number,
    recaptcha: string,
  ): Observable<any> 
  {
    const body = {
      claimNumber: claimNumber,
      birthYear: birthYear,
      recaptcha: recaptcha,
    }
    return this.http.post(
      this.routePrefix +
      "/validateClaimAndGenerateOTP", body);
  }

  otpValidation(otp: string, enrolId: number): Observable<any> {
    const body = {
      otp: otp,
      enrolId: enrolId
    };
    return this.http.post(this.routePrefix + "/otp", body, { headers: this.getRequestTokenHeader() });
  }

  otpValidationForAdditionalDocumentSubmission(
    otp: string,
    enrolId: number
  ): Observable<any> 
  {
    const body = {
      otp: otp,
      enrolId: enrolId
    };
    return this.http.post(
      this.routePrefix + "/OTPValidationForAdditionalDocumentSubmission",
      body,
      { headers: this.getRequestTokenHeader() }
    );
  }

  getByIdCustom(id: number): Observable<any> {
    return this.http.get(this.routePrefix + "/getByIdCustom/" + id);
  }

  getByClaimStatus(id: number): Observable<any> {
    return this.http.get(this.routePrefix + "/getByClaimStatus/" + id);
  }
  getByClaimStatusWithPagination(pagination: Pagination): Observable<any> {
    return this.http.post(this.routePrefix + "/getByClaimStatusWithPagination", pagination);
  }

  approve(data: any): Observable<any> {
    return this.http.post(this.routePrefix + "/approve", data);
  }

  approveMultiple(data: any[]): Observable<any> {
    return this.http.post(this.routePrefix + "/approveMultiple", data);
  }

  reject(data: any): Observable<any> {
    return this.http.post(this.routePrefix + "/reject", data);
  }

  rejectMultiple(data: any[]): Observable<any> {
    return this.http.post(this.routePrefix + "/rejectMultiple", data);
  }
}
